import HTTP from "../../../services/HTTP.js";

export const fetchUserRoleStats = async () => {
  const response = await HTTP.get("/dashboard/user-role-stats");
  return response.data;
};

export const fetchProjectWpTaskStats = async () => {
  const response = await HTTP.get("/dashboard/project-wp-task-stats")
  return response.data;
};

export const fetchTodaysMeetings = async () => {
  const response = await HTTP.get("/dashboard/todays-meetings")
  return response.data;
};

